// src/components/AuthPage.jsx
import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';
import TelegramAuth from './TelegramAuth';

const AuthPage = () => {
  const { user, loading, loginWithTelegram } = useAuth();
  const [isLoginMode, setIsLoginMode] = useState(true);
  const currentYear = new Date().getFullYear();
  const APP_VERSION = __APP_VERSION__;

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.origin !== window.location.origin) {
        return;
      }
      
      if (event.data && event.data.type === 'telegram_auth_data') {
        handleTelegramAuth(event.data.data);
      }
    };

    const checkTelegramDataOnReturn = () => {
      const telegramData = localStorage.getItem('telegram_auth_data');
      if (telegramData && !user) {
        try {
          const parsedData = JSON.parse(telegramData);
          handleTelegramAuth(parsedData);
          localStorage.removeItem('telegram_auth_data');
        } catch (err) {
          console.error('Error processing Telegram data on return:', err);
        }
      }
    };

    checkTelegramDataOnReturn();
    window.addEventListener('message', handleMessage);
    
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [user]);

  const handleTelegramAuth = async (telegramData) => {
    console.log('🔐 Handling Telegram authentication');
    try {
      await loginWithTelegram(telegramData);
    } catch (err) {
      console.error('❌ Telegram auth error:', err);
    }
  };

  return (
    <div className="d-flex flex-column min-vh-100">
      <Container fluid className="flex-grow-1 p-0">
        <Row className="g-0 h-100">
          <Col lg={6} className="gradient-bg text-white d-none d-lg-flex align-items-center">
            <div className="p-5">
              <div className="text-white-50 mb-5">Admin.Panel</div>
              <p className="fs-5 mb-5 opacity-75">
                ПОРТАЛ НЕЗАВИСИМОЙ ОЦЕНКИ КАЧЕСТВА УСЛОВИЙ ОКАЗАНИЯ УСЛУГ МЕДИЦИНСКИМИ ОРГАНИЗАЦИЯМИ
              </p>
              <div className="d-flex flex-column gap-3">
         
              </div>
            </div>
          </Col>

          <Col lg={6} className="d-flex align-items-center justify-content-center bg-light">
            <div className="w-100" style={{ maxWidth: '400px' }}>
              <Card className="auth-card">
                <Card.Body className="p-4">
                  <div className="nav nav-tabs-custom nav-fill mb-4">
                    <button 
                      className={`nav-link ${isLoginMode ? 'active' : ''}`}
                      onClick={() => setIsLoginMode(true)}
                    >
                      Войти
                    </button>
                   
                  </div>

           
                    <LoginForm onToggleMode={() => setIsLoginMode(false)} />
 

                  <div className="mt-4">
                    <div className="position-relative text-center mb-3">
                      <hr />
                      <span className="position-absolute top-50 start-50 translate-middle bg-white px-3 text-muted small">
                        {/* или войдите через */}
                      </span>
                    </div>
                    {/* <TelegramAuth 
                      onSuccess={() => {
                        console.log('Telegram auth successful');
                      }} 
                    /> */}
                  </div>
                </Card.Body>
              </Card>
            </div>
          </Col>
        </Row>
      </Container>

      <footer className="bg-white border-top py-3 mt-auto">
        <Container>
          <div className="text-center">
            <p className="text-muted small mb-0">
              HAKSTER | {currentYear} <small>.version {APP_VERSION}</small> 
            </p>
          </div>
        </Container>
      </footer>
    </div>
  );
};

export default AuthPage;